import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import Header from '../../components/Header';
import withGoBack from '../../common/withGoBack';
import withExpressCareSetsFilter from '../../common/withExpressCareSetsFilter';
import withOfficeSetsFilter from '../../common/withOfficeSetsFilter';
import Bugsnag from '../../helpers/bugsnag';
import { storeLastVisitedRoute } from '../../common/globals';

class Inventory extends Component {
  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onOfficeSets = () => {
    try {
      const { setOfficeSetsFilter } = this.props;
      this._onGoBack();
      browserHistory.push('/inventory/officeSets');
      setOfficeSetsFilter({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onExpressCareSets = () => {
    try {
      const { setExpressCareSetsFilter } = this.props;
      this._onGoBack();
      browserHistory.push('/inventory/expressCareSets');
      setExpressCareSetsFilter({});
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onConsignment = () => {
    try {
      this._onGoBack();
      storeLastVisitedRoute('consignment');
      browserHistory.push('/inventory/consignment');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackorders = () => {
    try {
      this._onGoBack();
      storeLastVisitedRoute('backorders');
      browserHistory.push('/inventory/backorders');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onShipments = () => {
    try {
      this._onGoBack();
      storeLastVisitedRoute('shipments');
      browserHistory.push('/inventory/shipments');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      storeLastVisitedRoute('/inventory');
      // storeLastVisitedRoute('');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <section className="list-section">
        <Header
          sideMenu
        />
        <section className="billing-section">
          <div className="container">
            <div className="row g-4">
              <div className="col-12">
                <Link className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width" onClick={this._onOfficeSets}>Office Sets</Link>
              </div>
              <div className="col-12">
                <Link className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width" onClick={this._onExpressCareSets}>ExpressCare Sets</Link>
              </div>
              <div className="col-12">
                <Link
                  className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width"
                  onClick={this._onConsignment}
                >Consignment
                </Link>
              </div>
              <div className="col-12">
                <Link
                  className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width"
                  onClick={this._onBackorders}
                >Backorders
                </Link>
              </div>
              <div className="col-12">
                <Link
                  className="btn btn-theme-alt btn-theme-outline-alt d-block btn-max-width"
                  onClick={this._onShipments}
                >Shipments
                </Link>
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default withOfficeSetsFilter(
  withExpressCareSetsFilter(
    withGoBack(
      withNotify(
        withLoader(
          Inventory
        )
      )
    )
  )
);
